import React from 'react';
import { Container, Card, Image, Label, Icon, Button } from 'semantic-ui-react';
import _ from 'underscore';
import defaultLeaderboardBanner from 'img/default-leaderboard-banner.png';

import LoadInline from '../loading/LoadInline.js';

import {colors, spacings, layout} from 'style';

var style = {
    content: {
        position:'relative'
    },
    body: {
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: layout.screenWidth,
        backgroundColor: 'white',
        padding: spacings.base,
        boxShadow: layout.screenShadow,
        minHeight: '100%',
    },
    cards: {
        justifyContent: 'center'
    },
    loaderContainer: {
        marginLeft:'50%'
    },
    card: {
        overflow:'hidden'
    },
    pseudoCard: {
        height: '0px',
        minHeight: '0px',
        border: 'none',
        boxShadow: 'none',
        visibility: 'hidden',
        marginTop: '0',
        marginBottom: '0',
    },
    seasonLabel: {
        border: '1px solid #1E0360',
        backgroundColor: '#fff',
        float: 'right',
    },
    image:{
        minHeight: '145px'
    }
};

const Leaderboards = (props) => (
    <div className="full-height" style={style.content}>
        <div style={style.body}>
            {props.busy && 
                <div style={style.loaderContainer}>
                    <LoadInline /> 
                </div>
            }
            {!props.busy && 
            <Card.Group style={style.cards}>
            {props.leaderboards.map((leaderboard)=>(
                        <Card key={leaderboard.id} style={style.card} onClick={()=>props.onClickLeaderboard(leaderboard.id)}>
                            <Image style={style.image} src={Boolean(leaderboard.banner && leaderboard.banner.url) ? leaderboard.banner.url : defaultLeaderboardBanner} alt="" />
                            <Card.Content>
                                <Card.Header>
                                    {leaderboard.title}
                                    {leaderboard.season && leaderboard.season.title &&
                                        <Label style={style.seasonLabel}>{leaderboard.season.title}</Label>
                                    }
                                </Card.Header>
                                {leaderboard.rank &&
                                <Card.Meta>#{leaderboard.rank}</Card.Meta>
                                }
                            </Card.Content>
                        </Card>
                    )
                )    
            }
            {/*hack to force left alignment of last row*/}
            {_.times(10, i=>(<Card key={i} style={{...style.card, ...style.pseudoCard}} />))}
            </Card.Group>
            }
        </div>
    </div>
);


export default Leaderboards;



// WEBPACK FOOTER //
// ./src/modules/leaderboards/Leaderboards.js